import { request, Reward } from "./client";
import { registerMessages } from "./errors";

registerMessages({
  "failed to list rewards": "Не удалось загрузить награды",
  "failed to create reward": "Не удалось добавить награду",
  "failed to update reward": "Не удалось сохранить награду",
  "failed to delete reward": "Не удалось удалить награду",
  "failed to read file": "Не удалось прочитать файл",
  "failed to create upload directory": "Не удалось сохранить картинку на сервере",
  "failed to create file": "Не удалось сохранить картинку на сервере",
  "failed to save file": "Не удалось сохранить картинку на сервере",
  "invalid image url": "Некорректная ссылка на картинку",
  "image not found": "Картинка уже удалена",
  "failed to delete image": "Не удалось удалить картинку",
});

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8080";

// The server accepts only these, detected from the file bytes.
export const REWARD_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

export type RewardInput = {
  title: string;
  description: string | null;
  image_url: string | null;
  count: number;
};

// Uploads are stored as "/uploads/images/…" and served by the API host, not
// by the admin panel.
export function rewardImageSrc(url: string): string {
  return /^https?:\/\//.test(url) ? url : `${API_BASE}${url}`;
}

export const rewardsCatalogApi = {
  list: () => request<Reward[] | null>("/api/rewards/"),

  create: (input: RewardInput) =>
    request<Reward>("/api/rewards/", { method: "POST", body: JSON.stringify(input) }),

  // The server overwrites every field, so the whole reward is always sent.
  update: (id: string, input: RewardInput) =>
    request<Reward>(`/api/rewards/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(input),
    }),

  remove: (id: string) =>
    request<void>(`/api/rewards/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
